<!-- 抽厕分析 -->
<template>
    <div class="main-area">
        <div v-if="$route.meta.rank == 3">
          <div v-show="pageShow">
            <el-breadcrumb separator=":">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item>抽厕分析</el-breadcrumb-item>
				        <div style="text-align: right"><el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">返回</el-button></div>
            </el-breadcrumb>
            <!--查询区域-->
            <el-row class="margin-top-10">
                <el-col :span="2" class="margin-top-10">
                    <label class="search-label">
                        区划:
                    </label>
                </el-col>
                <el-col :span="4" class="margin-top-10">
                    <el-cascader
                        :options="options"
                        :props="optionProps"
                        v-model="selectvalue"
                        change-on-select="ture"
                        clearable
                        :size="GLOBAL.config.systemSize"
                    ></el-cascader>
                </el-col>

                <el-col :span="2" class="margin-top-10">
                    <label class="search-label">
                        起止时间:
                    </label>
                </el-col>
                <el-col
                    :span="12"
                    class="margin-top-10"
                    style="text-align: left"
                >
                    <div class="block">
                        <el-date-picker
                            :size="GLOBAL.config.systemSize"
                            v-model="beginTime"
                            type="datetime"
                            value-format="yyyyMMddHHmmss"
                            placeholder="选择开始日期时间"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>

                        <el-date-picker
                            :size="GLOBAL.config.systemSize"
                            v-model="endTime"
                            type="datetime"
                            value-format="yyyyMMddHHmmss"
                            placeholder="选择结束日期时间"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                </el-col>

                <el-col :span="2" class="margin-top-10">
                    <el-button
                        type="primary"
                        @click="doSearch"
                        :size="GLOBAL.config.systemSize"
                        icon="el-icon-search"
                        >查询
                    </el-button>
                </el-col>
                <el-col :span="2" class="margin-top-10">
                    <el-button
                        type="primary"
                        @click="output"
                        :size="GLOBAL.config.systemSize"
                        icon="el-icon-upload2"
                        >导出
                    </el-button>
                </el-col>
            </el-row>

            <el-row class="margin-top-10">
                <!-- 图表 -->
                <el-col :span="16">
                    <div id="cc-all" class="cc-echarts"></div>
                </el-col>
                <!-- table -->
                <el-col :span="8">
                    <el-table
                        :data="tableData"
                        style="width: 100%;"
                        height="500"
                        element-loading-text="数据处理中...请稍等..."
                        @row-click="rowclick"
                        v-loading="loading"
                    >
                        <el-table-column prop="name" label="名称" width="180">
                        </el-table-column>
                        <el-table-column prop="pumpNum" label="报抽" sortable>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
          </div>
          <div v-show="!pageShow">
            <el-breadcrumb separator=":">
              <el-breadcrumb-item>当前位置</el-breadcrumb-item>
              <el-breadcrumb-item>抽厕分析</el-breadcrumb-item>
              <div style="text-align: right"><el-button @click="showBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">返回</el-button></div>
            </el-breadcrumb>
            <el-table
              :data="subordinate"
              style="width: 100%;"
              element-loading-text="数据处理中...请稍等..."
              v-loading="diatableloading"
            >
              <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
              <el-table-column prop="mbrxm" label="改厕户姓名" align="center"> </el-table-column>
              <el-table-column prop="mbrsjh" label="改厕户手机号" align="center"></el-table-column>
              <el-table-column
                prop="bcsj"
                :formatter="dateFormat"
                label="报抽时间"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="mbrsfz" label="身份证" align="center">
              </el-table-column>
              <el-table-column prop="counts" label="报抽次数" align="center" sortable>
              </el-table-column>
            </el-table>
            <el-pagination
              class="margin-top-10 margin-bottom-20"
              @size-change="tableSizeChange"
              @current-change="currentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizeList"
              :page-size="pagination.pageSize"
              :layout="pagination.layout"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import cascader from '../../components/Cascader'
export default {
    name: 'GCArchivesInfoTable',
    components: {
        cascader
    },

    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('gcUserInfo')),
            code: '340122000000', //缓存中code
            cmCode: '',
            updateTime: '', // 时间
            beginTime: '',
            endTime: '',
            visible: false, // 是否显示
            options: [], // 区域下拉
            optionProps: {
                checkStrictly: true,
                value: 'code',
                label: 'name',
                children: 'children'
            }, // 区域自定义匹配值
            selectvalue: '', // 区域选择的值
            loading: false, // 加载层
            diatableloading:false,
            tableData: [], // 表格数据
            subordinate: [], // 弹窗数据
            pagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            }, // 分页参数
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                }
            },
            pageShow: true
        }
    },

    methods: {
        showBack: function () {
          this.pageShow = true
        },
		    goBack: function () {
		        this.$router.go(-1)
		    },
        output: function(){
            let _this=this
            let info = {}
            let path = '/ccReportForm'
            let code = this.selectvalue.length!=0?this.selectvalue[this.selectvalue.length-1]:this.userInfo.ssqhdm
            if (code.substring(code.length-2, code.length) != '00') {
                info = {
                    current: 1,
                    size: 10000,
                    records: [
                        {
                            cmCode: this.selectvalue[this.selectvalue.length-1],
                            beginTime: _this.beginTime,
                            endTime: _this.endTime
                        }
                    ]
                }
                path = '/ccReportFormsq'
            } else {
                info = {
                    timeTwo: {
                        code :this.selectvalue.length!=0?this.selectvalue[this.selectvalue.length-1]:'',
                        beginTime: _this.beginTime,
                        endTime: _this.endTime,
                        type: '2',
                        flagNew:_this.selectvalue.length!=0?'2':'1'
                    }
                }
                path = '/ccReportForm'
            }
            // let  path='/ccReportForm'
            let name ="抽厕分析报表.xlsx"
            this.FUNCTIONS.systemFunction.postDownFileurl(this, {
               info: info,
               userInfo:{
                 user:JSON.parse(localStorage.getItem('gcUserInfo'))
               }
           },this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad +path,name)

        },
        // 查询
        doSearch: function() {
            if (this.beginTime && this.endTime) {
                if (!this.FUNCTIONS.systemFunction.compareDate(this.beginTime, this.endTime)) {
                    this.$message.warning('开始日期不能大于结束日期！')
                    return
                }
            }
            let code = this.selectvalue
            let yhlx = this.userInfo.yhlx
            let ssqhdm = this.userInfo.ssqhdm
            let flagTable = false
            if (typeof code == 'object') {
                // 判断县级选择村居
                if (code.length == 2) {
                    flagTable = true
                }
                code = code[code.length - 1]
            }
            if (yhlx == '3' || yhlx == '5') {
                if (code == undefined || code == '') {
                    this.getTableData()
                } else {
                    if (flagTable == true) {
                        this.getlastdata(code)
                    } else {
                        this.getTableDatacode(code)
                    }
                }
            } else {
                if (code == undefined || code == '') {
                    this.getTableDatacode(ssqhdm)
                } else {
                    this.getlastdata(code)
                }
            }
        },
        // 请求数据
        getTableData: function() {

            this.loading = true
            let _this = this
            // let searchParams = this.searchForm

            let param = {
                baseService:
                    _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl,
                timeTwo: {
                    beginTime: _this.beginTime,
                    endTime: _this.endTime,
                    type: '2'
                }
            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                // "getVillages",
                _this.GLOBAL.config.handleType.getVillages,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj
                        // _this.pagination.pageSize = resultData.obj.size
                        // _this.pagination.total = resultData.obj.total
                        // _this.pagination.currentPage = resultData.obj.current
                        _this.dealCCAllData('bar', resultData.obj)
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },

        // 区域code qingqiu
        getTableDatacode: function(code) {
            // this.loading = true
            let _this = this
            // let searchParams = this.searchForm

            let param = {
                baseService:
                    _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl,
                code: code,
                beginTime: _this.beginTime,
                endTime: _this.endTime,
                type: '2'
            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                // "getVillages",
                _this.GLOBAL.config.handleType.getVillagesGather,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        resultData.obj = resultData.obj.splice(1)
                        _this.tableData = resultData.obj

                        _this.dealCCAllData('bar', resultData.obj)
                    } else {
                        _this.$message.warning('获取数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },

        // 分页方法
        tableSizeChange: function(pageSize) {
            this.pagination.pageSize = pageSize
            let code = ''
            if (this.cmCode) {
              code = this.cmCode
            } else {
              code = '340122000000'
            }
            this.getlastdata(code)
        },
        currentChange: function(current) {
            this.pagination.currentPage = current
            let code = ''
            if (this.cmCode) {
              code = this.cmCode
            } else {
              code = '340122000000'
            }
            this.getlastdata(code)
        },

        // 抽测数据
        dealCCAllData: function(val, data) {
            let echartsdata = this.dealdata(data)
            let echarts = require('echarts')
            let myChart = echarts.init(document.getElementById('cc-all'),'light')
            myChart.clear()
            let that = this
            var option = {
                title: {
                    text: '抽厕数据'
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            show: true,
                            excludeComponents: ['toolbox'],
                            pixelRatio: 2
                        }
                    }
                },
                // barWidth : "200%",//柱图宽度
                // barGap:10,//柱图间距
                // dataZoom: {
                //     type: 'slider',
                //     show: true,
                //     start: 0,
                //     end: 10,
                //     handleSize: 8
                // },
                tooltip: {},
                legend: { data: ['报抽次数'] },
                grid: {
                    y2: 150
                },
                series: [
                    {
                        name: '报抽次数',
                        type: val,
                        data: echartsdata.ytitle,
						            showBackground: true,
						            backgroundStyle: {
						                color: 'rgba(220, 220, 220, 0.8)'
						            },
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'},
                                {type: 'min', name: '最小值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }
                    }
                ]
            }
            option.xAxis = {
                data: echartsdata.xtitle,
                type: 'category',
                axisLabel: {
                    showMaxLabel: true,

                    formatter: function (value) {
                        console.log(value)
                        // 让x轴字体垂直显示;如果柱形图x轴的信息太长会出现显示不全或者信息重叠在一起
                        return value.split('').join('\n')
                    },
                    textStyle: {
                        fontSize: 18
                    }
                    // interval: -1, // 横轴信息全部显示
                    // rotate: 5 // -15度角倾斜显示
                }
            }
            option.yAxis = {
                type: 'value'
            }
            myChart.on('click', function(param) {
                // 绑定跳转可视化界面
                that.cmCode = param.data.code
                // that.getlastdata(param.data.code)
                let code =null
                if(param.data.code){
                   code = param.data.code.substring(10, 12)
                }else{
                  code = null
                  param.data.code='340122000000'
                }

                if (code != '00') {
                    that.getlastdata(param.data.code)
                } else {
                    that.getTableDatacode(param.data.code)
                }
            })
            myChart.setOption(option)
        },
        // 数据处理
        dealdata: function(data) {
            console.log(data)
            let xtitle = [] // x轴
            let ytitle = [] // y轴
            for (let key in data) {
                xtitle.push(data[key].name)
                let y = {
                    value: data[key].pumpNum,
                    code: data[key].code,
                    name: data[key].name
                }
                ytitle.push(y)
            }
            return {
                xtitle: xtitle,
                ytitle: ytitle
            }
        },
        // 区划请求数据
        regionalization: function() {
            let _this = this
            let param = {
                baseService:
                    _this.GLOBAL.config.baseServiceType
                        .TGcOrganizationServiceImpl
            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getTreeXz,
                param,
                null,
                resultData => {
                    // _this.loading = false
                    if (resultData) {
                        console.log(resultData.obj)
                        // _this.options = resultData.obj
                        _this.options = JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.orgTreeName)))
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    // _this.loading = false
                }
            )
        },
        // 请求区划子集的数据
        getlastdata: function(code) {
		        this.pageShow = false
            // this.visible = true
            this.diatableloading=true
            let _this = this
            let param = {
                baseService:
                    _this.GLOBAL.config.baseServiceType.TGcBcxxServiceImpl,
                current: _this.pagination.currentPage,
                size: _this.pagination.pageSize,
                records: [
                    {
                        cmCode: code,
                        beginTime: _this.beginTime,
                        endTime: _this.endTime
                    }
                ]
            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.Bctool,
                param,
                null,
                resultData => {
                    _this.diatableloading=false
                    if (resultData) {
                        console.log(resultData.obj)
                        _this.subordinate = resultData.obj.records
                        _this.pagination.pageSize = resultData.obj.size
                        _this.pagination.currentPage = resultData.obj.current
                        _this.pagination.total = resultData.obj.total
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                   _this.diatableloading=false
                }
            )
        },
        // 表格
        rowclick(row) {
            console.log(row)
            this.cmCode = row.code
            let code = row.code.substring(10, 12)
            if (code != '00') {
                this.getlastdata(row.code)
            } else {
                this.getTableDatacode(row.code)
            }
        },
        // 弹框关闭
        handleClose(done) {
		        this.pageShow = true
            this.visible = false
        },
        // 格式化时间
        dateFormat: function(row, column, data) {
            if (!data) {
                return '-'
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/
            return data.replace(reg, '$1-$2-$3 $4:$5:$6')
        }
    },

    mounted() {

        this.code = this.userInfo.ssqhdm
        let yhlx = this.userInfo.yhlx
        let code = this.code //县
        console.log(code)
        this.regionalization() // 区域数据
        if (yhlx == '3' || yhlx == '5') {
            this.getTableData() // 表格数据
        } else {
            this.getTableDatacode(code)
        }
    }
}
</script>

<style scoped>
.upload-demo {
    text-align: left !important;
}

.cc-echarts {
    width: 100%;
    height: 500px;
    /* border: 2px solid blue; */
    margin-bottom: 20px;
    border-radius: 20px;
    padding-top: 5px;
    padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/DataAnalysis/WcAnalysis.vue